import { createFileRoute } from "@tanstack/react-router";
import { ProtectedPage } from "../app/route-boundaries";
import { AdminAIPage } from "../pages/AdminAIPage";
export const Route = createFileRoute("/system/ai/usage")({
  component: () => (
    <ProtectedPage>
      <AdminAIPage section="usage" />
    </ProtectedPage>
  ),
});
